export default __webpack_public_path__ + "static/fm-998ece035d1d39e76b710bdf071b2fd1.svg";